import { useSectionNav } from '@/hooks/useSectionNav';

const LOGO_URL =
  'https://storage.helloreaddy.io/project_files/09ddb6bb-c8bb-4f96-ab4a-8212390a75b9/ecc487b2-de93-4937-b65a-aebbf25289af_compressed_4cfb03bfc59e7a35381f77aa7964421.webp';

const columns = [
  {
    title: '平台中心',
    links: [
      { label: '课程中心', href: '#courses' },
      { label: '医院专科', href: '#hospitals' },
      { label: '优势病种', href: '#diseases' },
      { label: '成果转化', href: '#achievements' },
    ],
  },
  {
    title: '生态服务',
    links: [
      { label: '会议培训', href: '#activities' },
      { label: '视频中心', href: '#videos' },
      { label: '医师团队', href: '#doctors' },
      { label: '合作伙伴', href: '#partners' },
    ],
  },
  {
    title: '关于元合',
    links: [
      { label: '平台介绍', href: '#intro' },
      { label: '生态合作', href: '#contact' },
      { label: '联系我们', href: '#contact' },
      { label: '新闻动态', href: '#activities' },
    ],
  },
];

export default function Footer() {
  const { goToSection } = useSectionNav();
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="flex items-center justify-center bg-background-50 rounded-lg h-12 px-2 py-1">
                <img src={LOGO_URL} alt="元合 VITA" title="元合VITA 中西医结合智慧生态平台" className="h-10 w-auto" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-900">中西医结合智慧生态平台</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              以数智化转型、中西医协同为牵引，建设面向政府、医院、基层机构、医师、患者及产业合作方的全国性智慧生态服务门户。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-primary-500 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-primary-500 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-primary-500 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading font-semibold text-foreground-900 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} onClick={(e) => goToSection(e, link.href)} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 元合 VITA · 中西医结合智慧生态平台 版权所有</p>
          <p className="text-xs text-foreground-500">京ICP备2026000000号 · 全国性智慧生态服务门户</p>
        </div>
      </div>
    </footer>
  );
}